import { PayloadAction } from '@reduxjs/toolkit';

import { DesignData, DesignState } from 'editor/src/store/design/types';

import { PluginName } from '../../plugins/types';
import { personalizationPluginNames } from '../../variants/operation/updateProductPersonalizationOperation';

const setDesignDataReducer = (state: DesignState, action: PayloadAction<DesignData | undefined>) => {
  state.designData = action.payload;
  // Per-spread add/remove flags come from preflight for every multipage product,
  // flat books (brochures) included, so we trust them on load exactly as we do
  // for spread books (photobooks). The structural page math in
  // updateDesignPagesUtil only runs on mutation (add/remove/reorder), where it
  // keeps flat designs off the spread-book cover/-4 math.
  state.globalPlugins =
    action.payload?.plugins?.filter((plugin) => personalizationPluginNames.has(plugin as PluginName)) || [];
};

export default setDesignDataReducer;
